export * from './hide-fab.directive';


// WEBPACK FOOTER //
// ./src/app/shared/directives/hide-fab/index.ts